/**
 * How far ahead a media item, and each kept piece of a scene, is mounted so
 * its player has fetched and decoded its start before it plays (#77). A
 * first play fetches from the network; 1.5 s still paused the preview there.
 */
export const MEDIA_PREMOUNT_SECONDS = 4
